import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Select, Statistic } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { metaAdsApi } from '../../utils/api';

/**
 * Permet de choisir l'IA uniquement pour la session Meta Ads et affiche les coûts
 * estimés réellement journalisés. Ce choix ne modifie pas les paramètres généraux.
 */
const MetaAdsAIControls = ({ value, onChange }) => {
  const [usage, setUsage] = useState(null);

  /** Charge le total de tokens et de coût estimé déjà consommé par l'utilisateur. */
  useEffect(() => {
    const chargerUsage = async () => {
      try {
        const { data } = await metaAdsApi.getAIUsage();
        setUsage(data.data || null);
      } catch (error) {
        console.warn('Consommation IA Meta Ads indisponible:', error.message);
      }
    };
    chargerUsage();
  }, []);

  return (
    <Card size="small" className="shadow-sm" title={<span><RobotOutlined className="mr-2 text-blue-600" />IA utilisée pour cette session Meta Ads</span>}>
      <Row gutter={[16, 12]} align="middle">
        <Col xs={24} md={8}>
          <Select value={value.provider} onChange={provider => onChange({ provider, model: provider === 'openai' ? 'gpt-5.6-terra' : 'claude-opus-5' })} style={{ width: '100%' }} options={[{ value: 'openai', label: 'OpenAI' }, { value: 'claude', label: 'Claude' }]} />
        </Col>
        <Col xs={24} md={8}>
          <Select value={value.model} onChange={model => onChange({ ...value, model })} style={{ width: '100%' }} options={value.provider === 'openai' ? [{ value: 'gpt-5.6-terra', label: 'GPT-5.6 Terra' }] : [{ value: 'claude-opus-5', label: 'Claude Opus 5' }]} />
        </Col>
        <Col xs={12} md={4}><Statistic title="Tokens" value={(usage?.inputTokens || 0) + (usage?.outputTokens || 0)} /></Col>
        <Col xs={12} md={4}><Statistic title="Coût estimé" value={usage?.totalUsd || 0} precision={4} prefix="$" /></Col>
      </Row>
    </Card>
  );
};

export default MetaAdsAIControls;
